module.exports = __webpack_public_path__ + "a496aa051c4000f98f40e7919f82bfa9.pdf";